import { render } from "./newFleet.vue?vue&type=template&id=ed4de1be"
import script from "./newFleet.vue?vue&type=script&lang=js"
export * from "./newFleet.vue?vue&type=script&lang=js"

import "./newFleet.vue?vue&type=style&index=0&id=ed4de1be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__